module.exports = __webpack_public_path__ + "static/media/add_order_button.e284f3c4.svg";